import React from 'react';
import PropTypes from 'prop-types';

import GSFNSubstanceArticle from './GSFNSubstanceArticle';

import './GSFNSubstances.scss';

const GSFNSubstances = ({ substances, onSubstanceSelect }) => {
  return (
    <div className="insert-structure-from-name-substances">
      {substances.map((substance) =>
        <GSFNSubstanceArticle
          key={substance.rxId}
          substance={substance}
          onSubstanceSelect={onSubstanceSelect}
        />
      )}
    </div>
  );
}

GSFNSubstances.propTypes = {
  substances: PropTypes.array.isRequired,
  onSubstanceSelect: PropTypes.func.isRequired,
}

export default GSFNSubstances;
